/* 英富曼展会 */
// 5014,5743,7923,7924,7925,9816
// 369,2898,3991,3991,8588
export const blackList = [
  // 8588,
  8541, 3106, 3176, 3295, 6336, 1454, 3277, 3372, 6790, 6865, 7152, 6866, 6466, 3370, 8542, 9284,
  9283, 7121, 3770, 3769, 439, 7364, 3201, 3200,
  // 5743,
  // 7923,
  // 7924,
  // 7925,
  3907, 7304, 7305, 6275, 6805, 3256, 3317, 7508, 3026, 981, 483,
  // 3991,
  866, 8543, 3247,
  // 2898,
  3344, 8373, 3066, 3906, 8374, 3811, 3812, 3813, 4059, 6817
]
